import NS from 'src/ns';
import $ from 'jquery';

const expanded = {
  ns: '.stl-Expanded',
  observe: function() {
    const ns = this.ns;

    $(document)
      .on('click' + ns, '[aria-controls*="stl-Expanded"]', this._onClickTrigger.bind(this));
  },
  _onClickTrigger: function(e) {
    const $button = $(e.currentTarget);
    const isSelected = $button.attr('aria-selected') !== 'true';
    const targetSelector = $button.attr('aria-controls');
    const $panel = $('#' + targetSelector);

    this._changeButtonState($button, isSelected);
    this._changeExpanded($panel, isSelected);
  },
  _changePanelState: function($panel, isSelected) {
    $panel
      .attr('aria-hidden', !isSelected)
      .attr('aria-expanded', isSelected);
  },
  _changeButtonState: function($button, isSelected) {
    $button
      .attr('aria-selected', isSelected);
  },
  _changeExpanded: function($panel, isSelected) {
    this._changePanelState($panel, isSelected);

    if (isSelected) {
      this._openPanel($panel);
    } else {
      this._closePanel($panel);
    }
  },
  _openPanel: function($panel) {
    $panel.stop().slideDown(400);
  },
  _closePanel: function($panel) {
    $panel.stop().slideUp(400);
  }
};

export default NS.expanded = expanded;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/utility/expanded.js